'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _setup = require('redux/modules/setup');

var _lib = require('helpers/lib');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loginError: state.auth.loginError
  };
}, (0, _extends3.default)({}, authActions, { pushState: _reactRouterRedux.push, setPathName: _setup.setPathName })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FooterMobile, _Component);

  function FooterMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FooterMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FooterMobile.__proto__ || (0, _getPrototypeOf2.default)(FooterMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTab: _this.props.pathCurrent.replace('/', '') || 'home',
      showModalAlertLogin: false
    }, _this.changeTab = function (tab) {
      _this.setState({
        currentTab: tab
      });
      var link = '/';
      var tracking = { button: 'Bottom Bar' };
      if (tab === 'tai-khoan') {
        link = '/tai-khoan';
        _reactGa2.default.event({
          category: 'Bottom Bar',
          action: 'Clicked',
          label: 'Account'
        });
        tracking.label = 'Tài Khoản';
      }
      if (tab === 'home') {
        _reactGa2.default.event({
          category: 'Bottom Bar',
          action: 'Clicked',
          label: 'Home'
        });
        tracking.label = 'Địa Điểm';
      }
      if (tab === 'thong-bao') {
        link = '/thong-bao';
        _reactGa2.default.event({
          category: 'Bottom Bar',
          action: 'Clicked',
          label: 'Notification'
        });
        tracking.label = 'Thông Báo';
      }
      if (tab === 'kham-pha') {
        link = '/kham-pha';
        _reactGa2.default.event({
          category: 'Bottom Bar',
          action: 'Clicked',
          label: 'Discovery'
        });
        tracking.label = 'Khám Phá';
      }
      if (tab === 'lich-hen') {
        link = '/lich-hen';
        _reactGa2.default.event({
          category: 'Bottom Bar',
          action: 'Clicked',
          label: 'Calendar'
        });
        tracking.label = 'Lịch Hẹn';
      }
      if (tracking && tracking.label) _this.props.manualTrack(tracking);
      _this.props.pushState(link);
    }, _this.handleCloseModalAlertLogin = function () {
      _this.setState({ showModalAlertLogin: false });
    }, _this.addshop = function () {
      if (_this.props.user) {
        _this.props.pushState('/tao-cua-hang');
      } else {
        _this.setState({
          showModalAlertLogin: true
        });
      }
    }, _this.redirectLogin = function () {
      _this.props.setPathName('/tao-cua-hang');
      // this.props.pushState('/dang-nhap');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FooterMobile, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.pathCurrent !== this.props.pathCurrent) {
        var currentTab = nextProps.pathCurrent.replace('/', '') || 'home';
        this.setState({ currentTab: currentTab });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./FooterMobile.scss');
      var currentTab = this.state.currentTab;
      var showModalAlertLogin = this.state.showModalAlertLogin;

      if (!currentTab) {
        currentTab = 'home';
      }
      var _props = this.props,
          user = _props.user,
          noti = _props.noti;

      var avatarUrl = (0, _lib.getAvatar)(user);
      return _react2.default.createElement(
        'div',
        { className: styles.footerMobile },
        _react2.default.createElement(
          'div',
          { className: styles.tabs },
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'home' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('home');
              }
            },
            _react2.default.createElement('span', {
              className: styles.img + ' ' + styles.place,
              'aria-hidden': 'true'
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              '\u0110\u1ECBa \u0110i\u1EC3m'
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'kham-pha' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('kham-pha');
              }
            },
            _react2.default.createElement('span', {
              className: styles.img + ' ' + styles.search,
              'aria-hidden': 'true'
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'Kh\xE1m Ph\xE1'
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'lich-hen' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('lich-hen');
              }
            },
            _react2.default.createElement('span', {
              className: styles.img + ' ' + styles.booking,
              'aria-hidden': 'true'
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'L\u1ECBch H\u1EB9n'
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'thong-bao' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('thong-bao');
              }
            },
            _react2.default.createElement('span', {
              className: noti ? styles.img + ' ' + styles.hasNotification : styles.img + ' ' + styles.noNotification,
              'aria-hidden': 'true'
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'Th\xF4ng B\xE1o'
            )
          ),
          user ? _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'tai-khoan' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('tai-khoan');
              }
            },
            _react2.default.createElement('img', {
              src: avatarUrl,
              style: { backgroundImage: 'url:(' + avatarUrl + ')' },
              className: styles.avatarImg
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              (user.profile.name && user.profile.name.length > 10 ? user.profile.name.substring(0, 8) + '...' : user.profile.name) || 'Vô Danh'
            )
          ) : _react2.default.createElement(
            'div',
            {
              className: styles.tab + ' ' + (currentTab === 'tai-khoan' ? styles.active : ''),
              onClick: function onClick() {
                return _this2.changeTab('tai-khoan');
              }
            },
            _react2.default.createElement('span', {
              className: styles.img + ' ' + styles.account,
              'aria-hidden': 'true'
            }),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              'T\xE0i Kho\u1EA3n'
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlertLogin,
            hide: this.handleCloseModalAlertLogin,
            className: 'modal-alert-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalAlertLogin
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'B\u1EA1n c\u1EA7n ph\u1EA3i \u0111\u0103ng nh\u1EADp \u0111\u1EC3 c\xF3 th\u1EC3 t\u1EA1o shop m\u1EDBi'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: function onClick() {
                    return _this2.redirectLogin();
                  }
                },
                '\u0110\u0103ng nh\u1EADp'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnCancel,
                  onClick: this.handleCloseModalAlertLogin
                },
                'Hu\u1EF7'
              )
            )
          )
        )
      );
    }
  }]);
  return FooterMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  pathCurrent: _react.PropTypes.string,
  setPathName: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired,
  noti: _react.PropTypes.bool,

  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = FooterMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/FooterMobile.js
// module id = 1575
// module chunks = 0